/*
 Encapsulates the axa property of devis objects (DataDevis).
*/

const xenaToAxaForumule = {'M2':'Tiers Essentielle','M3':'Tiers Étendue','M4':false,'M7':'Tous risques Essentielle'}

const formuleToDisplay = {
    'Tiers Essentielle':'Tiers Essentielle',
    'Tiers Étendue':'Tiers étendue',
    'Tous risques Equilibre':'Tous risques Equilibre',
    'Tous risques Essentielle':'Tous risques Essentielle',
    'Tous risques Etendue':'Tous risques Etendue'
}

const formuleToExplain = {
    'Tiers Essentielle':'Responsabilité civile, Défense pénale et recours suite à accident, Assistance 30 km',
    'Tiers Étendue':'Responsabilité civile, Défense pénale et recours suite à accident, Assistance 30 km, Bris de glace, Catastrophe naturelle, technologique, Evénements climatiques et Attentats, Incendie et Vol',
    'Tous risques Equilibre':'Tous risques Equilibre',
    'Tous risques Essentielle':'Responsabilité civile, Défense pénale et recours suite à accident, Assistance 30 km, Bris de glace, Catastrophe naturelle, technologique, Evénements climatiques et Attentats, Incendie et Vol, Dommages tous accidents et vandalisme',
    'Tous risques Etendue':'Tous risques Etendue'
}

export default class DataAxa {

    constructor(axa,devis) {
        for ( const key in axa ) {
            this[key] = axa[key]
        }

        this.devis = devis
        this.formule = false
        this.fractionnement = false
        this.selectedOptions = devis.getValue('selectedOptions',[])
        this.hasTarif = false
        this.outputFancy = false 
        this.fancyDeflt = '-'
        this.fancyPost = '  €'
        this.deprecated = false
    }

    setDeprecated(parent) { 
        this.deprecated = parent
        return this
    }

    truncateString(str, maxLength) {
        if (str.length > maxLength) {
            return str.slice(0, maxLength) + "...";
        }
        return str;
    }

    getCleanError() {
        // Returns this.error if "clean" or a cleaned-up user-readable version

        if ( this.calculating ) return 'En cours de calcul ...'
        if ( !this.error ) return ''
        if ( this.error.match( /Call log|Timeout|Locator/ ) ) return 'Tarification impossible'
        if ( this.error === 'logout' ) return 'Serveur temporairement indisponible'
        return this.error
    }

    prevAxa() {
        // Loads up "previous" axa from devis into a new DataAxa object
        return new DataAxa( this.devis.prev_axa || {}, this.devis ).setDeprecated(this).setChoicesFromDevis()
    }

    swithToDeprecatedOnError() {
        return (( !this.hasAxa() )&&( this.hasValidPrevAxa() ))? this.prevAxa() : this
    }

    hasValidPrevAxa() {
        const { prev_axa } = this.devis
        return prev_axa && prev_axa.tarifs && !prev_axa.error
    }

    setChoicesFromDevis() {
        this.formule = xenaToAxaForumule[this.devis.getValue('formule')]
        this.fractionnement = {'A':'yearly','M':'monthly'}[this.devis.getValue('periodicite')]
        return this
    }

    setFormuleFromXena(xena) {
        this.formule = xenaToAxaForumule[xena]
        return this
    }

    mensuel(formule) {
        const f = formule ? xenaToAxaForumule[formule] : this.formule
        return f ? parseFloat( this.tarifs[f]['monthly'] ) + parseFloat(this.frais)/12 : false
    }

    mensuelSansFrais(formule) {
        const f = formule ? xenaToAxaForumule[formule] : this.formule
        return f ? parseFloat( this.tarifs[f]['monthly'] ) : false
    }

    annuel(formule) {
        const f = formule ? xenaToAxaForumule[formule] : this.formule
        return f ? parseFloat(this.tarifs[f]['yearly'])+parseFloat(this.frais) : false
    }

    annuelSansFrais(formule) {
        const f = formule ? xenaToAxaForumule[formule] : this.formule
        return f ? parseFloat(this.tarifs[f]['yearly']) : false
    }

    setFractionnement(fract) {
        this.fractionnement = {'A':'yearly','M':'monthly'}[fract]
        return this
    }

    hasAxa() {
        return ( this.tarifs && typeof this.tarifs === 'object' )&&( !this.error )
    }

    hasTarifs( formule ) {
        const f = ( formule ? xenaToAxaForumule[formule] : this.formule )
        return !!(f && this.tarifs?.[f])
    }

    coutTotal( formule, fract ) {
        const f = ( formule ? xenaToAxaForumule[formule] : this.formule )
        if ( !fract ) fract = this.fractionnement
        if ( !( this.tarifs && this.tarifs[f] )) return 0
        return ( fract == 'yearly' )
            ? parseFloat(this.annuel(formule))+parseFloat(this.toPayOptions(fract))
            : parseFloat(this.tarifs[f]['monthly'])*12+parseFloat(this.frais)+parseFloat(this.toPayOptions(fract))*12
    }

    echeance( formule, fract ) {
        const f = ( formule ? xenaToAxaForumule[formule] : this.formule )
        if ( !fract ) fract = this.fractionnement
        if ( !( this.tarifs && this.tarifs[f] )) return 0
        return ( fract == 'yearly' )
            ? this.annuel(formule)
            : this.mensuel(formule)
    }

    echeanceSansFrais( formule, fract ) {
        const f = ( formule ? xenaToAxaForumule[formule] : this.formule )
        if ( !fract ) fract = this.fractionnement
        if ( !( this.tarifs && this.tarifs[f] )) return 0
        return ( fract == 'yearly' )
            ? this.annuelSansFrais(formule)
            : this.mensuelSansFrais(formule)
    }

    echeanceOptions( formule, fract ) {
        if ( !fract ) fract = this.fractionnement
        return parseFloat(this.echeance( formule, fract ))+parseFloat(this.toPayOptions(fract))
    }

    echeanceOptionsSansFrais( formule, fract ) {
        if ( !fract ) fract = this.fractionnement
        return parseFloat(this.echeanceSansFrais( formule, fract ))+parseFloat(this.toPayOptions(fract))
    }

    getOptions() {
        if ( ! this.options ) return []
        return this.selectedOptions.map(
            key => this.options[key]
        ).filter( opt => opt )
    }

    toPayOptions(fract) {
        if ( !fract ) fract = this.fractionnement
        return this.getOptions().reduce( (sum,opt) => sum + parseFloat( opt[fract] ), 0 )
    }

    toPayYearlyOptions() {
        return this.toPayMonthlyYearlyOptions('yearly')
    }

    toPayMonthlyOptions() {
        return this.toPayMonthlyYearlyOptions('monthly')
    }

    setFancy(deflt,post) {
        this.fancyDeflt = deflt
        this.fancyPost = post
        return this
    }

    fancyPrice(price) {
        const fprice = parseFloat(price)
        if ( !fprice ) return this.fancyDeflt
        const pm = DataAxa.priceFormatter.format( fprice ).match(DataAxa.regPrice)
        return pm ? <>{pm[1]}<sup>{pm[2]}</sup>{this.fancyPost}</> : fprice
    }

    display() {
        return this.formule ? formuleToDisplay[this.formule] : false
    }

    explain() {
        return this.formule ? formuleToExplain[this.formule] : false
    }

    getRemainingMonthRatio(dateString,first_value) {
        const [day, month, year] = dateString.split('/').map(Number);
        // In JS, new Date(year, month, 0) returns the last day of the previous month index.
        // Since our 'month' variable is 1-based (1-12) and JS months are 0-based (0-11),
        // passing 'month' directly acts as the index for the *next* month, 
        // and day '0' gives us the last day of the *current* month.
        const totalDaysInMonth = new Date(year, month, 0).getDate();
        const remainingDays = totalDaysInMonth - day + 1 ;
        if ( remainingDays == totalDaysInMonth ) return first_value
        return remainingDays / totalDaysInMonth;
    }

    calculateProRata(day, month, year) {

        // Get last day of CURRENT month (using month index directly)
        const lastDayCurrent = new Date(year, month, 0).getDate();
        const remainingInMonth = lastDayCurrent - day + 1;

        // Get last day of NEXT month (JavaScript handles month 13 automatically)
        const lastDayNext = new Date(year, month + 1, 0).getDate();

        const totalDaysToPay = remainingInMonth + lastDayNext;
        
        return totalDaysToPay / 365;
    }

    calculateYearlyProRata(day, month, year) {

        // Start of the first day (00:00:00)
        const start = new Date(year, month - 1, day); 
        
        // Last day of the 12th month
        // Using 0 as the day gives us the last day of the month before
        const end = new Date(year, month + 11, 0); 

        // Difference in milliseconds
        const diffInMs = end.getTime() - start.getTime();
        
        // Convert to days and ADD 1 to include the final day's duration
        const totalDays = Math.round(diffInMs / (1000 * 60 * 60 * 24)) + 1;

        return totalDays / 365;
    }

    perception() {
        const {date_effet} = this.devis.params
        if ( ! date_effet ) return false

        const [day, month, year] = date_effet.split('/').map(Number);
        if ( day == 1 ) {
            switch ( this.fractionnement ) {
                case 'monthly':
                    return this.echeanceOptionsSansFrais(false,'monthly') + 6.5
                case 'yearly':
                    return this.echeanceOptionsSansFrais(false,'yearly')
            }
        } else {
            switch ( this.fractionnement ) {
                case 'monthly':
                    return this.calculateProRata(day,month,year)*12*this.echeanceOptionsSansFrais(false,'monthly') + 6.5
                case 'yearly':
                    return this.calculateYearlyProRata(day,month,year)*this.echeanceOptionsSansFrais(false,'yearly')
            }
        }
        return false
    }

    absoluteMonth(date) { // An absolute number allowing to make arithmetics on months
        const year = date.getFullYear()
        const month = date.getMonth() // keep january on 0
        return month + year*12
    }

    monthFirstPrelevement() {
        // Returns the month (relative to now : +1 = next month, 0 = current month, ...)
        // Returns the month of the first "prélevement" in monthly payments
        const {date_effet} = this.devis.params
        if ( ! date_effet ) return false
        const [day, month, year] = date_effet.split('/').map(Number);
        const absDateEffet = this.absoluteMonth( new Date(year, month - 1, day) );
        const absNow = this.absoluteMonth( new Date() );
        if ( day == 1 ) return absDateEffet-absNow+1
        else return absDateEffet-absNow+2
    }
}

DataAxa.regPrice = /^([\s0-9]+)(,[0-9]+)$/
DataAxa.priceFormatter = new Intl.NumberFormat('fr-FR',{
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

DataAxa.zFormToUniqueDetails = {
    'M2':<>
    <p>Indemnisation des dommages que vous pourriez causer à d'autres lors d'un accident de la circulation.

    Plafond : 
    100 000 000 € pour les dommages matériels, sans limite pour les dommages corporels.

    Pas de franchise, sauf si vous prêtez votre véhicule à d'autres conducteurs et sous certaines conditions (Franchise de 1500€).</p>
    <p>Défense de vos droits en cas de poursuite pénale et exercice d'un recours amiable ou judiciaire pour vous ou les personnes transportées, suite à un accident de la circulation.
    Plafond :
    10 000 € de frais (protection juridique et DPRSA)
    Seuil d'intervention :
    250 € 
    </p>
    <p>Assistance au véhicule : Dépannage et remorquage de votre véhicule 24h/24, 7j/7
    Assistance aux personnes.

    Zone de couverture: 
    Pays listés dans les Conditions Générales

    Seuil d'intervention:
    30 km de chez vous (ou 0 Km avec l'option) en cas de panne, et sans seuil d'intervention dans les autres cas.
    Assistance aux personnes : 30 km de votre domicile. 
    </p><p><b>Sécurité du conducteur et assistance 30km offertes. Pack sécurité du conducteur inclus : à hauteur de 100.000€ si taux d'invalidité &gt;10%</b></p></>,
    'M3':<>
    <p>Indemnisation des dommages que vous pourriez causer à d'autres lors d'un accident de la circulation.

    Plafond : 
    100 000 000 € pour les dommages matériels, sans limite pour les dommages corporels.

    Pas de franchise, sauf si vous prêtez votre véhicule à d'autres conducteurs et sous certaines conditions (Franchise de 1500€).</p>
    <p>Défense de vos droits en cas de poursuite pénale et exercice d'un recours amiable ou judiciaire pour vous ou les personnes transportées, suite à un accident de la circulation.
    Plafond :
    10 000 € de frais (protection juridique et DPRSA)
    Seuil d'intervention :
    250 € 
    </p>
    <p>Assistance au véhicule : Dépannage et remorquage de votre véhicule 24h/24, 7j/7
    Assistance aux personnes.

    Zone de couverture: 
    Pays listés dans les Conditions Générales

    Seuil d'intervention:
    30 km de chez vous (ou 0 Km avec l'option) en cas de panne, et sans seuil d'intervention dans les autres cas.
    Assistance aux personnes : 30 km de votre domicile. 
    </p><p><b>Sécurité du conducteur et assistance 30km offertes. Pack sécurité du conducteur inclus : à hauteur de 100.000€ si taux d'invalidité &gt;10%</b></p>
    <p>
        Prise en charge des dommages du pare-brise, bulle de carénage et optiques de phares avant et des glaces arrière et latérales. Les feux arrière sont couverts au titre de la garantie Dommages tous accidents, si celle-ci est souscrite.

        Plafond :
        Frais de réparation ou de remplacement

        Franchise :
        50€ + 10% sinistre
    </p>
    <p>
        Prise en charge des dommages résultant d'une catastrophe naturelle ou technologique, dès lors qu'elle est reconnue comme telle officiellement.

        Plafond :
        Valeur déterminée par un expert ou valeur majorée avec l'option Indemnisation renforcée.

        Franchise :
        Pas de franchise en cas de catastrophe technologique, franchise réglementaire en cas de catastrophe naturelle. 

    </p>
    <p>
        Prise en charge des dommages résultant de tempête, ouragan, cyclone, grêle, chute de neige, attentat ou acte de terrorisme.

        Plafond :
        Valeur déterminée par un expert ou valeur majorée avec l'option Indemnisation renforcée.

        Franchise :
        300€
    </p>
    <p>
        Prise en charge des dommages en cas de vol, tentative de vol, incendie, foudre ou explosion.

        Plafond :
        Valeur déterminée par un expert ou valeur majorée avec l'option Indemnisation renforcée.

        Franchise :
        300€

    </p>
    </>,
    'M7':<>
    <p>Indemnisation des dommages que vous pourriez causer à d'autres lors d'un accident de la circulation.

    Plafond : 
    100 000 000 € pour les dommages matériels, sans limite pour les dommages corporels.

    Pas de franchise, sauf si vous prêtez votre véhicule à d'autres conducteurs et sous certaines conditions (Franchise de 1500€).</p>
    <p>Défense de vos droits en cas de poursuite pénale et exercice d'un recours amiable ou judiciaire pour vous ou les personnes transportées, suite à un accident de la circulation.
    Plafond :
    10 000 € de frais (protection juridique et DPRSA)
    Seuil d'intervention :
    250 € 
    </p>
    <p>Assistance au véhicule : Dépannage et remorquage de votre véhicule 24h/24, 7j/7
    Assistance aux personnes.

    Zone de couverture: 
    Pays listés dans les Conditions Générales

    Seuil d'intervention:
    30 km de chez vous (ou 0 Km avec l'option) en cas de panne, et sans seuil d'intervention dans les autres cas.
    Assistance aux personnes : 30 km de votre domicile. 
    </p><p><b>Sécurité du conducteur et assistance 30km offertes. Pack sécurité du conducteur inclus : à hauteur de 100.000€ si taux d'invalidité &gt;10%</b></p>
    <p>
        Prise en charge des dommages du pare-brise, bulle de carénage et optiques de phares avant et des glaces arrière et latérales. Les feux arrière sont couverts au titre de la garantie Dommages tous accidents, si celle-ci est souscrite.

        Plafond :
        Frais de réparation ou de remplacement

        Franchise :
        50€ + 10% sinistre
    </p>
    <p>
        Prise en charge des dommages résultant d'une catastrophe naturelle ou technologique, dès lors qu'elle est reconnue comme telle officiellement.

        Plafond :
        Valeur déterminée par un expert ou valeur majorée avec l'option Indemnisation renforcée.

        Franchise :
        Pas de franchise en cas de catastrophe technologique, franchise réglementaire en cas de catastrophe naturelle. 

    </p>
    <p>
        Prise en charge des dommages résultant de tempête, ouragan, cyclone, grêle, chute de neige, attentat ou acte de terrorisme.

        Plafond :
        Valeur déterminée par un expert ou valeur majorée avec l'option Indemnisation renforcée.

        Franchise :
        300€
    </p>
    <p>
        Prise en charge des dommages en cas de vol, tentative de vol, incendie, foudre ou explosion.

        Plafond :
        Valeur déterminée par un expert ou valeur majorée avec l'option Indemnisation renforcée.

        Franchise :
        300€

    </p>
    <p>Garantie des dommages en cas d'accident (responsable ou non) ou de vandalisme.

        Plafond :
        Valeur déterminée par un expert ou valeur majorée avec l'option Indemnisation renforcée(selon véhicule).

        Franchise :
        300 € si vous êtes le conducteur. 1500 € si vous prêtez votre véhicule à d'autres conducteurs. 
    </p>
    </>

}

DataAxa.optionCodeToTitle = {
    'AST':'Assistance 0km',
    'IP1':'Assurance individuelle pilote jusqu\'à 500 000 €. Tx invalid. > 10%',
    'IP2':<>Assurance individuelle pilote jusqu'à 500 000 €. Tx invalid. &le; 10%</>,
    'AC1':false,
    'AC2':false
}

